(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[929],{

/***/ 89894:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _head = _interop_require_default(__webpack_require__(16505));

var statusCodes = {
  400: 'Bad Request',
  404: 'This page could not be found',
  405: 'Method Not Allowed',
  500: 'Internal Server Error'
};

function _getInitialProps(_ref) {
  var res = _ref.res,
      err = _ref.err;
  var statusCode = res && res.statusCode ? res.statusCode : err ? err.statusCode : 404;
  return {
    statusCode: statusCode
  };
}

var styles = {
  error: {
    fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
    height: '100vh',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  desc: {
    display: 'inline-block',
    textAlign: 'left',
    lineHeight: '49px',
    height: '49px',
    verticalAlign: 'middle'
  },
  h1: {
    display: 'inline-block',
    margin: 0,
    marginRight: '20px',
    padding: '0 23px 0 0',
    fontSize: '24px',
    fontWeight: 500,
    verticalAlign: 'top',
    lineHeight: '49px'
  },
  h2: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '49px',
    margin: 0,
    padding: 0
  }
};

var _Component;

var Error = /*#__PURE__*/function (_Component2) {
  _inherits(Error, _Component2);

  var _super = _createSuper(Error);

  function Error() {
    _classCallCheck(this, Error);

    return _super.apply(this, arguments);
  }

  _createClass(Error, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          statusCode = _this$props.statusCode,
          _this$props$withDarkM = _this$props.withDarkMode,
          withDarkMode = _this$props$withDarkM === void 0 ? true : _this$props$withDarkM;
      var title = this.props.title || statusCodes[statusCode] || 'An unexpected error has occurred';
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.error
      }, /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, statusCode ? "".concat(statusCode, ": ").concat(title) : 'Application error: a client-side exception has occurred')), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "\n                body { margin: 0; color: #000; background: #fff; }\n                .next-error-h1 {\n                  border-right: 1px solid rgba(0, 0, 0, .3);\n                }\n\n                ".concat(withDarkMode ? "@media (prefers-color-scheme: dark) {\n                  body { color: #fff; background: #000; }\n                  .next-error-h1 {\n                    border-right: 1px solid rgba(255, 255, 255, .3);\n                  }\n                }" : '')
        }
      }), statusCode ? /*#__PURE__*/_react["default"].createElement("h1", {
        className: "next-error-h1",
        style: styles.h1
      }, statusCode) : null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.desc
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        style: styles.h2
      }, this.props.title || statusCode ? title : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Application error: a client-side exception has occurred (see the browser console for more information)"), "."))));
    }
  }]);

  return Error;
}(_Component = _react["default"].Component);

Error.displayName = 'ErrorPage';
Error.getInitialProps = _getInitialProps;
Error.origGetInitialProps = _getInitialProps;
exports["default"] = Error;

/***/ }),

/***/ 22227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"FacetNavbar_nav__bDea3","facetSelected":"FacetNavbar_facetSelected___i2rv"};

/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89894)


/***/ }),

/***/ 16617:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MW": function() { return /* binding */ arrowDownIcon; },
/* harmony export */   "Z5": function() { return /* binding */ arrowUpIcon; },
/* harmony export */   "cR": function() { return /* binding */ wrenchIcon; },
/* harmony export */   "fT": function() { return /* binding */ getFaIcon; },
/* harmony export */   "wr": function() { return /* binding */ exclamationTriangleIcon; },
/* harmony export */   "yi": function() { return /* binding */ trashIcon; }
/* harmony export */ });
/* unused harmony exports searchIcon, profileIcon, heartIcon, infoIcon, closeIcon, thumbsUpIcon, eyeIcon, downloadIcon, editIcon, trashAltIcon, frownIcon, greenCheckIcon, windowCloseIcon, exclamationIcon, shoppingCartIcon, plusIcon, minusIcon, undoAltIcon, faceBook, twitter, instagram, youtube, linkedIn */
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23636);
/* harmony import */ var _fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60534);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73582);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59417);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







function getIconMap(iconName) {
  switch (iconName) {
    case 'arrowUpIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faArrowUp */ .FPD;
      break;

    case 'exclamationTriangleIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faExclamationTriangle */ .eHv;
      break;

    case 'wrenchIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faWrench */ .klh;
      break;

    case 'trashAltIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTrashAlt */ .I7k;
      break;

    case 'trashIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTrash */ .$aW;
      break;

    case 'undoAltIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faUndoAlt */ .R8d;
      break;

    case 'plusIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faPlus */ .r8p;
      break;

    case 'minusIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faMinus */ .Kl4;
      break;

    case 'listIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faList */ .Zrf;
      break;

    case 'thIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTh */ .szN;
      break;

    case 'arrowUpIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faArrowUp */ .FPD;
      break;

    case 'arrowDownIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faArrowDown */ .r5q;
      break;

    case 'searchIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faSearch */ .wn1;
      break;

    case 'profileIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faUser */ .ILF;
      break;

    case 'heartIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faHeart */ .m6i;
      break;

    case 'infoCircleIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faInfoCircle */ .sqG;
      break;

    case 'closeIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTimesCircle */ .nYk;
      break;

    case 'thumbsUpIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faThumbsUp */ .u8Q;
      break;

    case 'eyeIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faEye */ .Mdf;
      break;

    case 'downloadIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faDownload */ .q7m;
      break;

    case 'editIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faPen */ .IwR;
      break;

    case 'frownIcon':
      return _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faFrown */ .KfU;
      break;

    case 'repeatIcon':
      return _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faRepeat */ .jHE;
      break;
  }
}

_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_1__/* .config.autoAddCss */ .vc.autoAddCss = false;
var getFaIcon = function getFaIcon(iconName, size, color) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
    icon: getIconMap(iconName),
    size: size ? size : 'sm',
    style: {
      color: color ? color : ''
    }
  });
};
var arrowUpIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faArrowUp */ .FPD,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var arrowDownIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faArrowDown */ .r5q,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var searchIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faSearch */ .wn1,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var profileIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faUser */ .ILF,
  style: {
    color: '#3f51b5'
  }
});
var heartIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faHeart */ .m6i,
  style: {
    color: '#3f51b5'
  }
});
var infoIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faInfoCircle */ .sqG,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var closeIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTimesCircle */ .nYk,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var thumbsUpIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faThumbsUp */ .u8Q,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var eyeIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faEye */ .Mdf,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var downloadIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faDownload */ .q7m,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var editIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faPen */ .IwR,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var trashIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTrash */ .$aW,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var trashAltIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTrashAlt */ .I7k,
  size: "sm"
});
var frownIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faFrown */ .KfU,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var greenCheckIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faCheckCircle */ .f8k,
  size: "sm",
  color: "green"
});
var windowCloseIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faWindowClose */ ._Ob,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var exclamationIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faExclamation */ .WV2,
  size: "sm"
});
var wrenchIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faWrench */ .klh,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var exclamationTriangleIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faExclamationTriangle */ .eHv,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var shoppingCartIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faShoppingCart */ .sq$,
  size: "sm",
  style: {
    color: '#3f51b5'
  }
});
var plusIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faPlus */ .r8p,
  size: "sm"
});
var minusIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faMinus */ .Kl4,
  size: "sm"
});
var undoAltIcon = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faUndoAlt */ .R8d,
  size: "sm"
}); // Social Media Icons

var faceBook = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: ['facebook-square']
});
var twitter = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: ['twitter-square']
});
var instagram = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: ['instagram-square']
});
var youtube = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: ['youtube-square']
});
var linkedIn = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_0__/* .FontAwesomeIcon */ .G, {
  icon: ['linkedin']
});

/***/ }),

/***/ 90111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9229);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var DeleteConfirmationDialog = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
  var title = props.title,
      onConfirm = props.onConfirm,
      children = props.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "modal fade",
    ref: ref,
    tabIndex: "-1",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "modal-dialog  modal-dialog-centered",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "modal-content",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "modal-header",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h5", {
            className: "modal-title",
            id: "staticBackdropLabel",
            children: title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
            type: "button",
            className: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "modal-body",
          children: children
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "modal-footer",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: function onClick() {
              return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .hideModal */ .VG)(ref);
            },
            children: "No"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: function onClick() {
              (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .hideModal */ .VG)(ref);
              onConfirm();
            },
            children: "Yes"
          })]
        })]
      })
    })
  });
});
/* harmony default export */ __webpack_exports__["Z"] = (DeleteConfirmationDialog);

/***/ }),

/***/ 25915:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ search_SearchResults; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(64687);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icons.js
var Icons = __webpack_require__(16617);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/search/shared/SearchForm.js







var SearchForm = function SearchForm() {
  //console.log("Executing SearchForm.")
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(router.query.q ? router.query.q : ''),
      q = _useState[0],
      setQ = _useState[1];

  var _useState2 = (0,react.useState)(router.query.type ? router.query.type : 'list'),
      type = _useState2[0],
      setType = _useState2[1];

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    router.push(router.pathname + buildQueryString(q, type));
  };

  function buildQueryString(q, type) {
    console.log('Executing buildQueryString.');
    var queryString = '?';

    for (var _i = 0, _Object$entries = Object.entries(router.query); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      //console.log("Evaluating " + key + " = " + value)
      if (key !== 'type' && key !== 'q') {
        queryString += "".concat(key, "=").concat(value, "&");
      }
    }

    queryString += "type=".concat(type);

    if (q !== '') {
      q = encodeURIComponent(q);
      queryString += "&q=".concat(q);
    }

    return queryString;
  }

  var viewAll = function viewAll(e) {
    console.log('Executing viewAll.');
    e.preventDefault();
    setQ('');
    router.push(router.pathname + '?type=' + type);
  };

  var toggleToListView = function toggleToListView(e) {
    //console.log("Executing toggleToListView.")
    e.preventDefault();
    setType('list');
    router.push(router.pathname + buildQueryString(q, 'list')); // FIXME
    // MR 2021-12-08 This router.push is not ideal; but the setType wasn't actually doing anything.
    // Consider this a temporary fix.
    //setType('list')
  };

  var toggleToGridView = function toggleToGridView(e) {
    //console.log("Executing toggleToGridView.")
    e.preventDefault();

    if (router.query.search_category_facet) {
      window.alert("Grid display disabled because you've already selected a search category.");
    } else {
      setType('grid');
      router.push(router.pathname + buildQueryString(q, 'grid'));
    } //setType('grid')

  };

  var listViewButton = /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
    children: [(0,Icons/* getFaIcon */.fT)('listIcon', 'sm', null), "\xA0", "List"]
  });

  var gridViewButton = /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
    children: [(0,Icons/* getFaIcon */.fT)('thIcon', 'sm', null), "\xA0", "Grid"]
  });

  if (type === 'list') {
    gridViewButton = /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      href: "#",
      onClick: toggleToGridView,
      className: "active-view-mode",
      children: [(0,Icons/* getFaIcon */.fT)('thIcon', 'sm', null), "\xA0", "Grid"]
    });
  } else if (type === 'grid') {
    listViewButton = /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      href: "#",
      onClick: toggleToListView,
      className: "active-view-mode",
      children: [(0,Icons/* getFaIcon */.fT)('listIcon', 'sm', null), "\xA0", "List"]
    });
  }

  var viewOptions = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {});

  if (type === 'grid' && router.query.search_category_facet) {//if type is grid AND search_category_facet is present, hide the view options buttons
  } else {
    viewOptions = /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "View options:"
      }), "\xA0", "\xA0", listViewButton, "\xA0", "\xA0", gridViewButton]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
    onSubmit: handleSubmit,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-6 align-self-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          htmlFor: "q",
          className: "form-label sr-only",
          children: "Enter Query"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          onChange: function onChange(e) {
            return setQ(e.currentTarget.value);
          },
          value: q,
          className: "form-control",
          name: "q",
          id: "q"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-2 align-self-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "submit",
          className: "btn btn-primary",
          onClick: handleSubmit,
          children: "Go"
        }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "btn btn-primary",
          onClick: viewAll,
          children: "View All"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-4 align-self-end",
        id: "view-options",
        children: viewOptions
      })]
    })
  });
};

/* harmony default export */ var shared_SearchForm = (SearchForm);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./src/components/search/grid/GridSearchResult.js








var GridSearchResult = function GridSearchResult(_ref) {
  var group = _ref.group,
      count = _ref.count;
  var router = (0,next_router.useRouter)();
  var nextConfig = config();

  var buildLink = function buildLink(queryObject, group) {
    var baseUrl = 'products?';

    for (var _i = 0, _Object$entries = Object.entries(queryObject); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (key !== 'type') {
        baseUrl += "".concat(key, "=").concat(value, "&");
      }
    }

    baseUrl += "search_category_facet=".concat(group, "&");
    baseUrl += 'type=list';
    return baseUrl;
  };

  var handleViewGroup = function handleViewGroup(e) {
    router.push(buildLink(router.query, e.target.value));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "col-sm-6 col-md-4 mb-3",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "card h-100",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "card-body",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: "d-inline-block card-title",
          children: group.groupValue
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
          className: "d-inline-block card-subtitle text-muted",
          children: "".concat(count, " results")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "list-group list-group-flush",
          children: group.result.slice(0, 3).map(function (result) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "list-group-item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
                href: "/products/".concat(result.product_version_id),
                className: "text-decoration-none",
                children: result.dcterms_title ? result.dcterms_title : 'Untitled'
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-secondary",
                children: result.dcterms_alternative ? result.dcterms_alternative : 'No Description'
              })]
            }, result.product_version_id);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "card-footer text-muted",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          className: "btn btn-link",
          value: group.groupValue,
          onClick: handleViewGroup,
          children: ["View and filter all ", group.groupValue, " results"]
        })
      })]
    })
  });
};

/* harmony default export */ var grid_GridSearchResult = (GridSearchResult);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/components/search/shared/FacetNavbar.module.css
var FacetNavbar_module = __webpack_require__(22227);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
;// CONCATENATED MODULE: ./src/components/search/shared/FacetNavbar.js









var FacetNavbar = function FacetNavbar(_ref) {
  var content = _ref.content;

  if (!content) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {});
  }

  var router = (0,next_router.useRouter)();

  var buildLink = function buildLink(facetValue) {
    var baseUrl = 'products?';

    for (var _i = 0, _Object$entries = Object.entries(router.query); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (key !== 'type' && Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
          baseUrl += "".concat(key, "=").concat(value[i], "&");
        }
      } else if (key !== 'type') {
        baseUrl += "".concat(key, "=").concat(value, "&");
      }
    }

    if (facetValue) {
      baseUrl = baseUrl.replace(/(search_category_facet=).*?(&)/, '');
      baseUrl += "search_category_facet=".concat(facetValue, "&");
    } else {
      baseUrl = baseUrl.replace(/(search_category_facet=).*?(&)/, '');
    }

    baseUrl += 'type=list';
    return baseUrl;
  };

  var groupOrder = ['Programs', 'Studies', 'Data Packages', 'Analysis Reports', 'Questionnaires', 'Learning Reports', 'External Publications', 'Other Reports', 'Misc.'];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    className: "".concat(FacetNavbar_module.nav, " m-2 p-2"),
    "aria-label": "breadcrumb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
      className: "breadcrumb",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: "breadcrumb-item",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
          href: "".concat(buildLink(null)),
          className: classnames((0,defineProperty/* default */.Z)({}, FacetNavbar_module.facetSelected, !router.query.hasOwnProperty('search_category_facet') || router.query['search_category_facet'] === null)),
          children: "All Results"
        })
      }), groupOrder.map(function (groupLabel, i) {
        if (content[groupLabel]) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "breadcrumb-item",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(next_link, {
              href: "".concat(buildLink(groupLabel)),
              className: classnames((0,defineProperty/* default */.Z)({}, FacetNavbar_module.facetSelected, router.query.hasOwnProperty('search_category_facet') && router.query['search_category_facet'] === groupLabel)),
              children: [groupLabel, "(", content[groupLabel], ")"]
            })
          }, i);
        }
      })]
    })
  });
};

/* harmony default export */ var shared_FacetNavbar = (FacetNavbar);
// EXTERNAL MODULE: ./src/components/utils.js
var utils = __webpack_require__(9229);
;// CONCATENATED MODULE: ./src/components/search/search.js






function retrieveFacetNavbarContent(_x) {
  return _retrieveFacetNavbarContent.apply(this, arguments);
}

function _retrieveFacetNavbarContent() {
  _retrieveFacetNavbarContent = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator.mark(function _callee(query) {
    var apiPath, _i, _Object$entries, _Object$entries$_i, key, value, i, nextConfig, data;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiPath = 'products/facets/search_category_facet?';

            for (_i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
              _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];

              if (key === 'type') {// ignore, type=list|grid is not relevant for this query, and produces an error upstream
              } else if (key !== 'search_category_facet' && Array.isArray(value)) {
                for (i = 0; i < value.length; i++) {
                  apiPath += "".concat(key, "=").concat(value[i], "&");
                }
              } else if (key !== 'search_category_facet') {
                if (key === 'q') {
                  value = encodeURIComponent(value);
                  apiPath += "".concat(key, "=").concat(value, "&");
                } else {
                  apiPath += "".concat(key, "=").concat(value, "&");
                }
              }
            }

            apiPath = apiPath.substring(0, apiPath.length - 1);
            nextConfig = config();
            _context.next = 6;
            return (0,utils/* fetcher */._i)("".concat(nextConfig.publicRuntimeConfig.apiProxyBasePath, "/").concat(apiPath));

          case 6:
            data = _context.sent;

            if (!data) {
              _context.next = 11;
              break;
            }

            if (!(data.facet_counts && data.facet_counts.facet_fields && data.facet_counts.facet_fields.search_category_facet)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", data.facet_counts.facet_fields.search_category_facet);

          case 10:
            console.error('api did not return expected content');

          case 11:
            return _context.abrupt("return", null);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _retrieveFacetNavbarContent.apply(this, arguments);
}


;// CONCATENATED MODULE: ./src/components/search/grid/GridSearchResults.js












var GridSearchResults = function GridSearchResults(_ref) {
  var results = _ref.results,
      numFound = _ref.numFound;

  //console.log("Executing GridSearchResults.")
  if (!results) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: "Error; no results received."
    });
  }

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      facetNavbarContent = _useState[0],
      setFacetNavbarContent = _useState[1];

  (0,react.useEffect)(function () {
    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator.mark(function _callee() {
      var facetNavbarContent;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return retrieveFacetNavbarContent(router.query);

            case 2:
              facetNavbarContent = _context.sent;
              setFacetNavbarContent(facetNavbarContent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [results]); // This array establishes the order of grid boxes, since it's a relatively arbitrary sort.

  var groupOrder = ['Programs', 'Studies', 'Data Packages', 'Analysis Reports', 'Questionnaires', 'Learning Reports', 'External Publications', 'Other Reports', 'Misc.']; // 'Programs' aren't returned by the query; included so the full list of search categories is present, in case MCC changes their minds
  // 'Misc.' is that the search returns for objects that don't have a searchCategory value established.

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row searchRow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Showing ", numFound, " results."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_SearchForm, {}), router.pathname.includes('products') && /*#__PURE__*/(0,jsx_runtime.jsx)(shared_FacetNavbar, {
        content: facetNavbarContent
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "row searchRow",
      children: numFound > 0 ? groupOrder.map(function (groupLabel, i) {
        var group = results.find(function (group) {
          return group.groupValue === groupLabel;
        });

        if (group && group !== null) {
          var count = facetNavbarContent && facetNavbarContent[groupLabel] ? facetNavbarContent[groupLabel] : '?';
          return /*#__PURE__*/(0,jsx_runtime.jsx)(grid_GridSearchResult, {
            group: group,
            count: count
          }, i);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "alert alert-light",
        role: "alert",
        children: "No results found."
      })
    })]
  });
};

/* harmony default export */ var grid_GridSearchResults = (GridSearchResults);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./src/components/products.js
var products = __webpack_require__(44264);
// EXTERNAL MODULE: ./src/components/productVersionEditor/DeleteConfirmationDialog.js
var DeleteConfirmationDialog = __webpack_require__(90111);
// EXTERNAL MODULE: ./src/components/userContext.js + 1 modules
var userContext = __webpack_require__(58282);
;// CONCATENATED MODULE: ./src/components/search/list/ListSearchResult.js










var ListSearchResult = function ListSearchResult(_ref) {
  var result = _ref.result,
      index = _ref.index,
      sourcePath = _ref.sourcePath,
      page = _ref.page,
      rows = _ref.rows;

  function buildTitle() {
    var title = '';

    if (result.product_type === 'data activity' && result.dcterms_location) {
      title += result.dcterms_location + ' - ';
    }

    if (result.dcterms_title) {
      title += result.dcterms_title;
    } else {
      title += 'Untitled Product';
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
      href: '/products/' + result.product_version_id,
      children: title
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
      children: [(page - 1) * rows + Number(index) + 1, "."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Cat. ID",
      children: result.product_id
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Eval. ID",
      children: result.imeta_evaluationId ? result.imeta_evaluationId : '-'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Title",
      children: buildTitle()
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Version Label",
      children: result.version_label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Product Type",
      children: result.product_type
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Status",
      children: result.status
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Assignments",
      children: result.participants ? result.participants.join(', ') : '-'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
      "data-label": "Actions",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductVersionActions, {
        result: result,
        sourcePath: sourcePath
      })
    })]
  });
};

var ProductVersionActions = function ProductVersionActions(_ref2) {
  var result = _ref2.result,
      sourcePath = _ref2.sourcePath;
  var user = (0,userContext/* useUserContext */.S)();
  var userIcpsrPermitted = user.roles.find(function (r) {
    return r.roleLabel === 'mcc-icpsr-permitted';
  });
  var modalRef = (0,react.useRef)();

  var deleteRow = function deleteRow() {
    (0,utils/* showModal */.K4)(modalRef);
  };

  var onDeleteConfirm = function onDeleteConfirm() {
    (0,products/* deleteProductVersion */.EP)(result.product_version_id, sourcePath);
  };

  var deleteAction = //only appears if product is unpublished and user is mcc-icpsr-permitted
  userIcpsrPermitted && user.isMccIcpsrPermitted === true && result.status != 'published' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "#",
      onClick: deleteRow,
      children: "delete"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("em", {
      children: "for testing/admin only"
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [deleteAction, /*#__PURE__*/(0,jsx_runtime.jsx)(DeleteConfirmationDialog/* default */.Z, {
      ref: modalRef,
      title: 'Delete Confirmation',
      onConfirm: onDeleteConfirm,
      children: "Are you sure you want to delete this product?"
    })]
  });
};

/* harmony default export */ var list_ListSearchResult = (ListSearchResult);
;// CONCATENATED MODULE: ./src/components/search/list/ProductsPagination.js






function prevPath(sourcePath, page, query) {
  var link = sourcePath + '?';
  query.page = page;

  for (var _i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    switch (key) {
      case 'page':
        if (query.page > 1) {
          link += '&page=' + (Number(query.page) - 1);
        } else {
          link += '&page=' + Number(query.page);
        }

        break;

      default:
        link += '&' + key + '=' + encodeURIComponent(value);
    }
  }

  return link;
}

function nextPath(sourcePath, page, query) {
  var link = sourcePath + '?';
  query.page = page;

  for (var _i2 = 0, _Object$entries2 = Object.entries(query); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = (0,slicedToArray/* default */.Z)(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];

    switch (key) {
      case 'page':
        link += '&page=' + (Number(query.page) + 1);
        break;

      default:
        link += '&' + key + '=' + encodeURIComponent(value);
    }
  }

  return link;
}

function nextNextPath(sourcePath, page, query) {
  var link = sourcePath + '?';
  query.page = page;

  if (typeof query == 'undefined') {
    link += 'page=' + (page + 2);
  } else {
    for (var _i3 = 0, _Object$entries3 = Object.entries(query); _i3 < _Object$entries3.length; _i3++) {
      var _Object$entries3$_i = (0,slicedToArray/* default */.Z)(_Object$entries3[_i3], 2),
          key = _Object$entries3$_i[0],
          value = _Object$entries3$_i[1];

      switch (key) {
        case 'page':
          link += '&page=' + (Number(query.page) + 2);
          break;

        default:
          link += '&' + key + '=' + encodeURIComponent(value);
      }
    }
  }

  return link;
}

function firstPath(sourcePath, page, query) {
  var link = sourcePath + '?';
  query.page = page;

  for (var _i4 = 0, _Object$entries4 = Object.entries(query); _i4 < _Object$entries4.length; _i4++) {
    var _Object$entries4$_i = (0,slicedToArray/* default */.Z)(_Object$entries4[_i4], 2),
        key = _Object$entries4$_i[0],
        value = _Object$entries4$_i[1];

    switch (key) {
      case 'page':
        if (query.page > 1) {
          link += '&page=1';
        } else {
          link += '&page=' + Number(query.page);
        }

        break;

      default:
        link += '&' + key + '=' + encodeURIComponent(value);
    }
  }

  return link;
}

function lastPath(sourcePath, page, query, totalPages) {
  var link = sourcePath + '?';
  query.page = page;

  for (var _i5 = 0, _Object$entries5 = Object.entries(query); _i5 < _Object$entries5.length; _i5++) {
    var _Object$entries5$_i = (0,slicedToArray/* default */.Z)(_Object$entries5[_i5], 2),
        key = _Object$entries5$_i[0],
        value = _Object$entries5$_i[1];

    switch (key) {
      case 'page':
        link += '&page=' + totalPages;
        break;

      default:
        link += '&' + key + '=' + encodeURIComponent(value);
    }
  }

  return link;
}

var ProductsPagination = function ProductsPagination(_ref) {
  var totalPages = _ref.totalPages,
      page = _ref.page,
      query = _ref.query,
      rows = _ref.rows,
      startIndex = _ref.startIndex,
      endIndex = _ref.endIndex,
      sourcePath = _ref.sourcePath;
  var nextPage = page + 1;
  var nextNextPage = page + 2;
  var firstPageClass = 'page-item';
  var lastPageClass = 'page-item';
  var prevPageClass = 'page-item';
  var nextPageClass = 'page-item';
  var nextNextPageClass = 'page-item';

  if (page >= totalPages) {
    nextPageClass = 'page-item d-none';
    nextNextPageClass = 'page-item d-none';
    lastPageClass = 'page-item d-none';
  }

  if (page + 1 >= totalPages) {
    nextNextPageClass = 'page-item d-none';
  }

  if (page == 1) {
    prevPageClass = 'page-item d-none';
    firstPageClass = 'page-item d-none';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: "pagination",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: firstPageClass,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
          href: "".concat(firstPath(sourcePath, page, query)),
          className: "page-link",
          children: "First"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: prevPageClass,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
          href: "".concat(prevPath(sourcePath, page, query)),
          className: "page-link",
          children: "Previous"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: "page-item active",
        "aria-current": "page",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "page-link",
          children: page
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: nextPageClass,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
          href: "".concat(nextPath(sourcePath, page, query)),
          className: "page-link",
          children: nextPage
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: nextNextPageClass,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
          href: "".concat(nextNextPath(sourcePath, page, query)),
          className: "page-link",
          children: nextNextPage
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: nextPageClass,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
          href: "".concat(nextPath(sourcePath, page, query)),
          className: "page-link",
          children: "Next"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        className: lastPageClass,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
          href: "".concat(lastPath(sourcePath, page, query, totalPages)),
          className: "page-link",
          children: "Last"
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/search/list/SortWithinPage.js





var SortWithinPage = function SortWithinPage(_ref) {
  var sortBy = _ref.sortBy;
  var router = (0,next_router.useRouter)();

  var handleChange = function handleChange(e) {
    router.query.sortBy = e.target.value;
    router.push(router);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      id: "sortWithinPage-label",
      htmlFor: "sortWithinPage",
      className: "form-label",
      children: "Sort within page"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
      id: "sortWithinPage",
      value: sortBy,
      onChange: handleChange,
      className: "form-select",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "score",
        children: "Relevancy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "product_version_id",
        children: "ID"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "dcterms_title",
        children: "Title"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "product_type",
        children: "Product Type"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "version_label",
        children: "Version"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "status",
        children: "Status"
      })]
    })]
  });
};

/* harmony default export */ var list_SortWithinPage = (SortWithinPage);
;// CONCATENATED MODULE: ./src/components/search/list/SortAllResults.js






var SortAllResults = function SortAllResults(_ref) {
  var sort = _ref.sort;
  var router = (0,next_router.useRouter)(); // Bizarre nonsense I have to build because there's no hook to remove a query parameter via router.
  // sortBy has to be removed so that top-level sort can trigger.

  var revisedQuery = {};

  var handleChange = function handleChange(e) {
    for (var _i = 0, _Object$entries = Object.entries(router.query); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (key !== 'sortBy') {
        revisedQuery[key] = router.query[key];
      }
    }

    revisedQuery.sort = e.target.value;
    revisedQuery.page = 1;
    router.query = revisedQuery;
    router.push(router);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      id: "sortAll-label",
      htmlFor: "sortAll",
      className: "form-label",
      children: "Sort all"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
      id: "sortAll",
      value: sort,
      onChange: handleChange,
      className: "form-select",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "score desc",
        children: "Relevancy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "product_id asc",
        children: "Catalog ID"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "imeta_evaluationId asc",
        children: "Evaluation ID"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "dcterms_title_sort asc",
        children: "Title"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "product_type asc",
        children: "Product Type"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "status asc",
        children: "Status"
      })]
    })]
  });
};

/* harmony default export */ var list_SortAllResults = (SortAllResults);
;// CONCATENATED MODULE: ./src/components/search/list/SelectRowsPerPage.js






var SelectRowsPerPage = function SelectRowsPerPage(_ref) {
  var rows = _ref.rows;
  var router = (0,next_router.useRouter)(); // Bizarre nonsense I have to build because there's no hook to remove a query parameter via router.
  // sortBy has to be removed so that top-level sort can trigger.

  var revisedQuery = {};

  var handleChange = function handleChange(e) {
    for (var _i = 0, _Object$entries = Object.entries(router.query); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (key !== 'rows') {
        revisedQuery[key] = router.query[key];
      }
    }

    revisedQuery.rows = e.target.value;
    revisedQuery.page = 1;
    router.query = revisedQuery;
    router.push(router);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      id: "sortWithinPage-label",
      htmlFor: "rows",
      className: "form-label",
      children: "Products per page"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
      id: "rows",
      value: rows,
      onChange: handleChange,
      className: "form-select",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "10",
        children: "10"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "20",
        children: "20"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "50",
        children: "50"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "100",
        children: "100"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
        value: "500",
        children: "500"
      })]
    })]
  });
};

/* harmony default export */ var list_SelectRowsPerPage = (SelectRowsPerPage);
;// CONCATENATED MODULE: ./src/components/search/list/ListSearchResults.js

















var ListSearchResults = function ListSearchResults(_ref) {
  var results = _ref.results,
      numFound = _ref.numFound,
      sourcePath = _ref.sourcePath,
      totalPages = _ref.totalPages,
      rows = _ref.rows;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      facetNavbarContent = _useState[0],
      setFacetNavbarContent = _useState[1];

  if (!results) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: "Error, no results received."
    });
  }

  (0,react.useEffect)(function () {
    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator.mark(function _callee() {
      var facetNavbarContent;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return retrieveFacetNavbarContent(router.query);

            case 2:
              facetNavbarContent = _context.sent;
              setFacetNavbarContent(facetNavbarContent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [results]);
  var page = parseInt(router.query.page || '1');
  var startIndex = Number(page - 1) * Number(rows) + 1;
  var endIndex = startIndex - 1 + Number(rows);
  var indexOfLast = numFound < endIndex ? numFound : endIndex;
  var sort = router.query.sort || 'score desc';
  var sortingParam = router.query.sortBy || '';

  var sortedResults = (0,toConsumableArray/* default */.Z)(results).sort(function (a, b) {
    if (typeof a[sortingParam] === 'string') {
      return a[sortingParam].localeCompare(b[sortingParam]);
    } else {
      return a[sortingParam] - b[sortingParam];
    }
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row searchRow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Showing ", numFound > 0 ? startIndex + '-' + indexOfLast + ' of ' : '', " ", numFound, " results."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_SearchForm, {}), router.pathname.includes('products') && /*#__PURE__*/(0,jsx_runtime.jsx)(shared_FacetNavbar, {
        content: facetNavbarContent
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row searchRow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(list_SelectRowsPerPage, {
          rows: rows
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(list_SortAllResults, {
          sort: sort
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(list_SortWithinPage, {
          sortBy: sortingParam
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col align-self-end",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductsPagination, {
          totalPages: totalPages,
          page: page,
          query: router.query,
          sourcePath: sourcePath && sourcePath != '/' ? sourcePath + '/' : '/'
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "row searchRow",
      id: "list-search-results",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
        className: "table table-responsive table-bordered",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: ' '
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: "Cat.\xA0ID"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: "Eval.\xA0ID"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-5",
              children: "Title"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: "Version"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: "Product Type"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: "Status"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: "Assignments"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
              scope: "col",
              className: "col-1",
              children: "Actions"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
          children: numFound > 0 ? sortedResults.map(function (result, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(list_ListSearchResult, {
              result: result,
              index: i,
              sourcePath: sourcePath,
              page: page,
              rows: rows
            }, result.product_version_id);
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
            align: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              colSpan: 8,
              children: "No results found."
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("tfoot", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductsPagination, {
                totalPages: totalPages,
                page: page,
                query: router.query,
                sourcePath: sourcePath && sourcePath != '/' ? sourcePath + '/' : '/'
              })
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var list_ListSearchResults = (ListSearchResults);
;// CONCATENATED MODULE: ./src/components/search/shared/FacetValue.js






var FacetValue = function FacetValue(_ref) {
  var facetValue = _ref.facetValue,
      facetCount = _ref.facetCount,
      field = _ref.field,
      sourcePath = _ref.sourcePath;
  //console.log("Executing FacetValue")
  var router = (0,next_router.useRouter)();

  if (facetAlreadySelected(router.query, field, facetValue)) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FacetValueSelected, {
      sourcePath: sourcePath,
      facetValue: facetValue,
      field: field,
      query: router.query
    });
  } else {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FacetValueNotSelected, {
      sourcePath: sourcePath,
      facetValue: facetValue,
      facetCount: facetCount,
      field: field,
      query: router.query
    });
  }
};

function facetAlreadySelected(query, field, value) {
  //console.log("Executing facetAlreadySelected for field = " + field)
  if (!query.hasOwnProperty(field)) {
    return false;
  }

  if (Array.isArray(query[field])) {
    if (query[field].indexOf(value) === -1) {
      return false;
    }
  } else if (query[field] !== value) {
    return false;
  }

  return true;
}

var FacetValueNotSelected = function FacetValueNotSelected(_ref2) {
  var facetValue = _ref2.facetValue,
      facetCount = _ref2.facetCount,
      field = _ref2.field,
      query = _ref2.query,
      sourcePath = _ref2.sourcePath;
  var path = buildAddFacetValueLink(query, field, facetValue, sourcePath);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
      href: "".concat(path),
      children: facetValue
    }), "\xA0", "(", facetCount, ")"]
  });
};

var FacetValueSelected = function FacetValueSelected(_ref3) {
  var facetValue = _ref3.facetValue,
      field = _ref3.field,
      query = _ref3.query,
      sourcePath = _ref3.sourcePath;
  var path = buildRemoveFacetValueLink(query, field, sourcePath);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    children: [facetValue, "\xA0", "(", /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
      href: "".concat(path),
      children: "X"
    }), ")"]
  });
};

function buildAddFacetValueLink(query, field, value, sourcePath) {
  //console.log("Executing buildAddFacetValueLink.")
  // When adding a new facet value, reset start to 1.
  var link = sourcePath + '?';

  for (var _i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        _value = _Object$entries$_i[1];

    switch (key) {
      case 'page':
        link += 'page=1';
        break;

      default:
        link += key + '=' + encodeURIComponent(_value);
    }

    link += '&';
  }

  link += field + '=' + encodeURIComponent(value);
  return link;
}

function buildRemoveFacetValueLink(query, field, sourcePath) {
  //console.log("Executing buildRemoveFacetValueLink.")
  // When removing a facet value, reset start to 1.
  var link = sourcePath + '?';

  for (var _i2 = 0, _Object$entries2 = Object.entries(query); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = (0,slicedToArray/* default */.Z)(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];

    switch (key) {
      case 'page':
        link += 'page=1';
        break;

      case field:
        // do not add to link
        break;

      default:
        link += key + '=' + encodeURIComponent(value);
    }

    link += '&';
  }

  link = link.slice(0, link.length - 1);
  return link;
}

/* harmony default export */ var shared_FacetValue = (FacetValue);
;// CONCATENATED MODULE: ./src/components/search/shared/FacetViewAll.js





var limitToDisplay = 10;

var FacetViewAll = function FacetViewAll(_ref) {
  var field = _ref.field,
      sourcePath = _ref.sourcePath,
      limit = _ref.limit;
  //console.log("Executing FacetViewAll.")
  var router = (0,next_router.useRouter)();

  if (router.query.hasOwnProperty(field) || limit < limitToDisplay) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var link = buildViewAllLink(router.query, field, sourcePath);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link, {
      href: "".concat(link),
      children: "view all"
    })
  });
};

function buildViewAllLink(query, field, sourcePath) {
  //console.log("Executing buildAddFacetValueLink.")
  // When adding a new facet value, reset start to 1.
  var link = sourcePath + '/facets/' + field + '?';

  for (var _i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (link.substr(link.length - 1, 1) !== '?') {
      link += '&';
    }

    switch (key) {
      case "page":
        link += 'page=1';
        break;

      default:
        link += key + '=' + encodeURIComponent(value);
    }
  }

  return link;
}

/* harmony default export */ var shared_FacetViewAll = (FacetViewAll);
;// CONCATENATED MODULE: ./src/components/search/shared/Facet.js







var Facet = function Facet(_ref) {
  var facetField = _ref.facetField,
      facet = _ref.facet,
      sourcePath = _ref.sourcePath,
      index = _ref.index;
  //console.log("Executing Facet.")
  var router = (0,next_router.useRouter)();
  var expanded = false;

  if (index === 0 || router.query.hasOwnProperty(facetField)) {
    expanded = true;
  }

  function buildFacetLabel() {
    var facetLabel = facetField.replace('_facet', '').replaceAll('_', ' ').replace('dcterms', '').replace('imeta', '');

    if (facetLabel === 'location') {
      facetLabel = 'country';
    } else if (facetLabel === 'environment') {
      facetLabel = 'location type';
    } else if (facetLabel === 'solutions') {
      facetLabel = 'intervention types';
    } else if (facetLabel === 'rounds') {
      facetLabel = 'study phase';
    } else if (facetLabel === 'topic') {
      facetLabel = 'cross-sector themes';
    }

    return facetLabel;
  }

  if (Object.keys(facet).length === 0) {
    // Don't display facets that have zero values.
    return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "accordion-item",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "accordion-header",
      id: 'heading' + facetField,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'accordion-button ' + (expanded ? '' : 'collapsed'),
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": '#collapse' + facetField,
        "aria-expanded": expanded,
        "aria-controls": 'collapse' + facetField,
        children: buildFacetLabel()
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: 'collapse' + facetField,
      className: 'accordion-collapse collapse ' + (expanded ? 'show' : ''),
      "aria-labelledby": 'heading' + facetField,
      "data-bs-parent": "#facetAccordion",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "accordion-body",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "mccFacetUL",
          children: [Object.keys(facet).map(function (key, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_FacetValue, {
              facetValue: key,
              facetCount: facet[key],
              field: facetField,
              sourcePath: sourcePath
            }, 'facet_' + facetField + '_' + i);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_FacetViewAll, {
            field: facetField,
            sourcePath: sourcePath,
            limit: Object.keys(facet).length
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var shared_Facet = (Facet);
;// CONCATENATED MODULE: ./src/components/search/shared/Facets.js







var Facets = function Facets(_ref) {
  var facets = _ref.facets,
      sourcePath = _ref.sourcePath,
      numFound = _ref.numFound;
  //console.log("Executing Facets.")
  //console.log(facets)
  //Bootstrap accordiion require bootstrap js, use useEffect to import bootstrap js at client side (code runs first on server and then on client) to avoid "document is undefined" error. Source: https://stackoverflow.com/questions/67845378/how-can-i-use-bootstrap-5-with-next-js
  (0,react.useEffect)(function () {
    if (typeof document !== undefined) {
      (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e(/* import() */ 734).then(__webpack_require__.t.bind(__webpack_require__, 43734, 19));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    id: "facets",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: "Facets"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "accordion",
      id: "facetAccordion",
      children: numFound > 0 ? Object.keys(facets.facet_fields).map(function (key, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_Facet, {
          facetField: key,
          facet: facets.facet_fields[key],
          sourcePath: sourcePath,
          index: i
        }, 'facet_' + i);
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "No results found."
      })
    })]
  });
};

/* harmony default export */ var shared_Facets = (Facets);
;// CONCATENATED MODULE: ./src/components/search/SearchResults.js







var SearchResults = function SearchResults(_ref) {
  var results = _ref.results,
      facets = _ref.facets,
      numFound = _ref.numFound,
      sourcePath = _ref.sourcePath,
      rows = _ref.rows,
      totalPages = _ref.totalPages;

  if (!results) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: "Error; no results received."
    });
  } //console.log(sourcePath);


  var router = (0,next_router.useRouter)();
  var displayType = router.query.type || 'list';

  if (router.query.search_category_facet) {
    displayType = 'list';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_Facets, {
        facets: facets,
        sourcePath: sourcePath ? sourcePath : '/products',
        numFound: numFound
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-10",
      children: displayType === 'grid' ? /*#__PURE__*/(0,jsx_runtime.jsx)(grid_GridSearchResults, {
        results: results,
        numFound: numFound
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(list_ListSearchResults, {
        results: results,
        numFound: numFound,
        sourcePath: sourcePath ? sourcePath : '/products',
        totalPages: totalPages,
        rows: rows
      })
    })]
  });
};

/* harmony default export */ var search_SearchResults = (SearchResults);

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

}]);